import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FaqComponent } from './faq/faq.component';
import { FaqsListComponent } from './faqs-list/faqs-list.component';
import { CommonModule } from '@angular/common';
import { FileDownloadComponent } from './file-download/file-download.component';
import { EntryStatusComponent } from './entry-status/entry-status.component';
import { SequenceCardComponent } from './sequence-card/sequence-card.component';
import { StatusMessageComponent } from './status-message/status-message.component';
import { NotificationMsgComponent } from './notification-msg/notification-msg.component';

const declarations = [FaqComponent, FaqsListComponent, FileDownloadComponent, EntryStatusComponent, StatusMessageComponent, 
  SequenceCardComponent, NotificationMsgComponent];

@NgModule({
  declarations: [...declarations],
  exports: [...declarations],
  imports: [CommonModule],
})
export class SharedModule {}
